import { PropsWithChildren, useMemo } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import useErrorMonitoring from '@ui/shared/hooks/useErrorMonitoring'

interface ErrorBoundaryProps {
  onError?: () => void
}

export default function ErrorBoundary({
  onError = undefined,
  children = '',
}: PropsWithChildren<ErrorBoundaryProps>) {
  const errorMonitoring = useErrorMonitoring()

  const AppErrorBoundary = useMemo(() => errorMonitoring?.createErrorBoundary(), [errorMonitoring])

  if (errorMonitoring?.isRunning() && !!AppErrorBoundary) {
    return (
      <ReactErrorBoundary fallbackRender={() => null}>
        <AppErrorBoundary FallbackComponent={() => null} onError={onError}>
          {children}
        </AppErrorBoundary>
      </ReactErrorBoundary>
    )
  }

  return (
    <ReactErrorBoundary fallbackRender={() => null} onError={onError}>
      {children}
    </ReactErrorBoundary>
  )
}
